// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * TaskAttributes type.
 * @typedef {object} TaskAttributes
 * @property {string} id - Attribute value.
 * @property {number} agentAttemptsCount - Attribute value.
 * @property {Date | null} agentClaimExpiresAt - Attribute value.
 * @property {string | null} agentClaimedBy - Attribute value.
 * @property {string | null} agentContextJson - Attribute value.
 * @property {Date | null} agentLastHeartbeatAt - Attribute value.
 * @property {string | null} agentState - Attribute value.
 * @property {Record<string, string>} automationRuntimeLinks - Attribute value.
 * @property {string | null} automationRuntimeStatus - Attribute value.
 * @property {boolean} canClose - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {string | null} description - Attribute value.
 * @property {string | null} name - Attribute value.
 * @property {number | null} priority - Attribute value.
 * @property {string | null} projectId - Attribute value.
 * @property {string | null} state - Attribute value.
 * @property {string | null} taskTypeId - Attribute value.
 * @property {string} translatedState - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 * @property {string | null} userId - Attribute value.
 */
/**
 * Attributes accepted for nested uploadedFiles writes.
 * @typedef {object} TaskUploadedFilesNestedAttributes
 * @property {string | null} [title] - Nested title value.
 * @property {FrontendModelAttributeValue} [file] - Nested file value.
 * @property {string | null} [userId] - Nested userId value.
 */
/**
 * Attributes accepted by TaskCreateAttributes.
 * @typedef {object} TaskCreateAttributes
 * @property {TaskAttributes["description"] | null} [description] - Permitted description value.
 * @property {TaskAttributes["name"] | null} [name] - Permitted name value.
 * @property {TaskAttributes["priority"] | null} [priority] - Permitted priority value.
 * @property {TaskAttributes["projectId"] | null} [projectId] - Permitted projectId value.
 * @property {TaskAttributes["state"] | null} [state] - Permitted state value.
 * @property {TaskAttributes["taskTypeId"] | null} [taskTypeId] - Permitted taskTypeId value.
 * @property {Array<TaskUploadedFilesNestedAttributes>} [uploadedFilesAttributes] - Permitted nested uploadedFilesAttributes values.
 * @property {TaskAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Attributes accepted by TaskUpdateAttributes.
 * @typedef {object} TaskUpdateAttributes
 * @property {TaskAttributes["description"] | null} [description] - Permitted description value.
 * @property {TaskAttributes["name"] | null} [name] - Permitted name value.
 * @property {TaskAttributes["priority"] | null} [priority] - Permitted priority value.
 * @property {TaskAttributes["projectId"] | null} [projectId] - Permitted projectId value.
 * @property {TaskAttributes["state"] | null} [state] - Permitted state value.
 * @property {TaskAttributes["taskTypeId"] | null} [taskTypeId] - Permitted taskTypeId value.
 * @property {Array<TaskUploadedFilesNestedAttributes>} [uploadedFilesAttributes] - Permitted nested uploadedFilesAttributes values.
 */
/**
 * Frontend model for Task.
 * @augments {FrontendModelBase<TaskAttributes, TaskCreateAttributes, TaskUpdateAttributes, TaskAttributes["id"], string>}
 */
class Task extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "Task",
      attributes: [
        "id",
        "agentAttemptsCount",
        "agentClaimExpiresAt",
        "agentClaimedBy",
        "agentContextJson",
        "agentLastHeartbeatAt",
        "agentState",
        "automationRuntimeLinks",
        "automationRuntimeStatus",
        "canClose",
        "createdAt",
        "description",
        "name",
        "priority",
        "projectId",
        "state",
        "taskTypeId",
        "translatedState",
        "updatedAt",
        "userId",
      ],
      collectionCommands: [
        "agentReady",
        "cleanupStaleAgentClaims",
      ],
      memberCommands: [
        "addDailyWork",
        "agentUpdate",
        "assignToAgent",
        "claimForAgent",
        "close",
        "heartbeatAgentClaim",
        "markAgentReady",
        "postAutomationReply",
        "releaseAgentClaim",
        "resumeAgentWork",
        "syncAutomationRuntime",
      ],
      nestedAttributes: {
        uploadedFiles: {},
      },
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      comments: {type: "hasMany"},
      project: {type: "belongsTo"},
      taskAssignedUsers: {type: "hasMany"},
      taskBoards: {type: "hasMany"},
      taskType: {type: "belongsTo"},
      uploadedFiles: {type: "hasMany"},
      user: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      comments: "Comment",
      project: "Project",
      taskAssignedUsers: "TaskAssignedUser",
      taskBoards: "TaskBoard",
      taskType: "TaskType",
      uploadedFiles: "UploadedFile",
      user: "User",
    }
  }

  /** @returns {TaskAttributes["id"]} - Attribute value. */
  id() { return /** @type {TaskAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {TaskAttributes["id"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {TaskAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {TaskAttributes["agentAttemptsCount"]} - Attribute value. */
  agentAttemptsCount() { return /** @type {TaskAttributes["agentAttemptsCount"]} */ (this.readAttribute("agentAttemptsCount")) }

  /**
   * @param {TaskAttributes["agentAttemptsCount"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["agentAttemptsCount"] | null} - Assigned value.
   */
  setAgentAttemptsCount(newValue) { return /** @type {TaskAttributes["agentAttemptsCount"] | null} */ (this.setAttribute("agentAttemptsCount", newValue)) }

  /** @returns {TaskAttributes["agentClaimExpiresAt"]} - Attribute value. */
  agentClaimExpiresAt() { return /** @type {TaskAttributes["agentClaimExpiresAt"]} */ (this.readAttribute("agentClaimExpiresAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setAgentClaimExpiresAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("agentClaimExpiresAt", newValue)) }

  /** @returns {TaskAttributes["agentClaimedBy"]} - Attribute value. */
  agentClaimedBy() { return /** @type {TaskAttributes["agentClaimedBy"]} */ (this.readAttribute("agentClaimedBy")) }

  /**
   * @param {TaskAttributes["agentClaimedBy"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["agentClaimedBy"] | null} - Assigned value.
   */
  setAgentClaimedBy(newValue) { return /** @type {TaskAttributes["agentClaimedBy"] | null} */ (this.setAttribute("agentClaimedBy", newValue)) }

  /** @returns {TaskAttributes["agentContextJson"]} - Attribute value. */
  agentContextJson() { return /** @type {TaskAttributes["agentContextJson"]} */ (this.readAttribute("agentContextJson")) }

  /**
   * @param {TaskAttributes["agentContextJson"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["agentContextJson"] | null} - Assigned value.
   */
  setAgentContextJson(newValue) { return /** @type {TaskAttributes["agentContextJson"] | null} */ (this.setAttribute("agentContextJson", newValue)) }

  /** @returns {TaskAttributes["agentLastHeartbeatAt"]} - Attribute value. */
  agentLastHeartbeatAt() { return /** @type {TaskAttributes["agentLastHeartbeatAt"]} */ (this.readAttribute("agentLastHeartbeatAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setAgentLastHeartbeatAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("agentLastHeartbeatAt", newValue)) }

  /** @returns {TaskAttributes["agentState"]} - Attribute value. */
  agentState() { return /** @type {TaskAttributes["agentState"]} */ (this.readAttribute("agentState")) }

  /**
   * @param {TaskAttributes["agentState"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["agentState"] | null} - Assigned value.
   */
  setAgentState(newValue) { return /** @type {TaskAttributes["agentState"] | null} */ (this.setAttribute("agentState", newValue)) }

  /** @returns {TaskAttributes["automationRuntimeLinks"]} - Attribute value. */
  automationRuntimeLinks() { return /** @type {TaskAttributes["automationRuntimeLinks"]} */ (this.readAttribute("automationRuntimeLinks")) }

  /**
   * @param {TaskAttributes["automationRuntimeLinks"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["automationRuntimeLinks"] | null} - Assigned value.
   */
  setAutomationRuntimeLinks(newValue) { return /** @type {TaskAttributes["automationRuntimeLinks"] | null} */ (this.setAttribute("automationRuntimeLinks", newValue)) }

  /** @returns {TaskAttributes["automationRuntimeStatus"]} - Attribute value. */
  automationRuntimeStatus() { return /** @type {TaskAttributes["automationRuntimeStatus"]} */ (this.readAttribute("automationRuntimeStatus")) }

  /**
   * @param {TaskAttributes["automationRuntimeStatus"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["automationRuntimeStatus"] | null} - Assigned value.
   */
  setAutomationRuntimeStatus(newValue) { return /** @type {TaskAttributes["automationRuntimeStatus"] | null} */ (this.setAttribute("automationRuntimeStatus", newValue)) }

  /** @returns {TaskAttributes["canClose"]} - Attribute value. */
  canClose() { return /** @type {TaskAttributes["canClose"]} */ (this.readAttribute("canClose")) }

  /**
   * @param {TaskAttributes["canClose"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["canClose"] | null} - Assigned value.
   */
  setCanClose(newValue) { return /** @type {TaskAttributes["canClose"] | null} */ (this.setAttribute("canClose", newValue)) }

  /** @returns {TaskAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {TaskAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {TaskAttributes["description"]} - Attribute value. */
  description() { return /** @type {TaskAttributes["description"]} */ (this.readAttribute("description")) }

  /**
   * @param {TaskAttributes["description"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["description"] | null} - Assigned value.
   */
  setDescription(newValue) { return /** @type {TaskAttributes["description"] | null} */ (this.setAttribute("description", newValue)) }

  /** @returns {TaskAttributes["name"]} - Attribute value. */
  name() { return /** @type {TaskAttributes["name"]} */ (this.readAttribute("name")) }

  /**
   * @param {TaskAttributes["name"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["name"] | null} - Assigned value.
   */
  setName(newValue) { return /** @type {TaskAttributes["name"] | null} */ (this.setAttribute("name", newValue)) }

  /** @returns {TaskAttributes["priority"]} - Attribute value. */
  priority() { return /** @type {TaskAttributes["priority"]} */ (this.readAttribute("priority")) }

  /**
   * @param {TaskAttributes["priority"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["priority"] | null} - Assigned value.
   */
  setPriority(newValue) { return /** @type {TaskAttributes["priority"] | null} */ (this.setAttribute("priority", newValue)) }

  /** @returns {TaskAttributes["projectId"]} - Attribute value. */
  projectId() { return /** @type {TaskAttributes["projectId"]} */ (this.readAttribute("projectId")) }

  /**
   * @param {TaskAttributes["projectId"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["projectId"] | null} - Assigned value.
   */
  setProjectId(newValue) { return /** @type {TaskAttributes["projectId"] | null} */ (this.setAttribute("projectId", newValue)) }

  /** @returns {TaskAttributes["state"]} - Attribute value. */
  state() { return /** @type {TaskAttributes["state"]} */ (this.readAttribute("state")) }

  /**
   * @param {TaskAttributes["state"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["state"] | null} - Assigned value.
   */
  setState(newValue) { return /** @type {TaskAttributes["state"] | null} */ (this.setAttribute("state", newValue)) }

  /** @returns {TaskAttributes["taskTypeId"]} - Attribute value. */
  taskTypeId() { return /** @type {TaskAttributes["taskTypeId"]} */ (this.readAttribute("taskTypeId")) }

  /**
   * @param {TaskAttributes["taskTypeId"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["taskTypeId"] | null} - Assigned value.
   */
  setTaskTypeId(newValue) { return /** @type {TaskAttributes["taskTypeId"] | null} */ (this.setAttribute("taskTypeId", newValue)) }

  /** @returns {TaskAttributes["translatedState"]} - Attribute value. */
  translatedState() { return /** @type {TaskAttributes["translatedState"]} */ (this.readAttribute("translatedState")) }

  /**
   * @param {TaskAttributes["translatedState"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["translatedState"] | null} - Assigned value.
   */
  setTranslatedState(newValue) { return /** @type {TaskAttributes["translatedState"] | null} */ (this.setAttribute("translatedState", newValue)) }

  /** @returns {TaskAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {TaskAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /** @returns {TaskAttributes["userId"]} - Attribute value. */
  userId() { return /** @type {TaskAttributes["userId"]} */ (this.readAttribute("userId")) }

  /**
   * @param {TaskAttributes["userId"] | null} newValue - New attribute value.
   * @returns {TaskAttributes["userId"] | null} - Assigned value.
   */
  setUserId(newValue) { return /** @type {TaskAttributes["userId"] | null} */ (this.setAttribute("userId", newValue)) }

  /**
   * Runs agentReady.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/task-automation-command-types.js").TaskAgentReadyResponse>} - Command response.
   */
  static async agentReady(...commandArguments) {
    return /** @type {import("../../../shared/task-automation-command-types.js").TaskAgentReadyResponse} */ (await this.executeCustomCommand({
      commandName: "agent-ready",
      commandType: "agent-ready",
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs cleanupStaleAgentClaims.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/task-automation-command-types.js").TaskCleanupStaleAgentClaimsResponse>} - Command response.
   */
  static async cleanupStaleAgentClaims(...commandArguments) {
    return /** @type {import("../../../shared/task-automation-command-types.js").TaskCleanupStaleAgentClaimsResponse} */ (await this.executeCustomCommand({
      commandName: "cleanup-stale-agent-claims",
      commandType: "cleanup-stale-agent-claims",
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: this.resourcePath()
    }))
  }

  /**
   * Runs addDailyWork.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{timelog: {id: string, date: Date | null, comment: string | null, timeSeconds: number}}>} - Command response.
   */
  async addDailyWork(...commandArguments) {
    return /** @type {{timelog: {id: string, date: Date | null, comment: string | null, timeSeconds: number}}} */ (await Task.executeCustomCommand({
      commandName: "add-daily-work",
      commandType: "add-daily-work",
      memberId: this.scalarPrimaryKeyValue("Custom member command Task#addDailyWork"),
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Task.resourcePath()
    }))
  }

  /**
   * Runs agentUpdate.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/task-automation-command-types.js").TaskAgentUpdateResponse>} - Command response.
   */
  async agentUpdate(...commandArguments) {
    return /** @type {import("../../../shared/task-automation-command-types.js").TaskAgentUpdateResponse} */ (await Task.executeCustomCommand({
      commandName: "agent-update",
      commandType: "agent-update",
      memberId: this.scalarPrimaryKeyValue("Custom member command Task#agentUpdate"),
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Task.resourcePath()
    }))
  }

  /**
   * Runs assignToAgent.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/task-automation-command-types.js").TaskAssignToAgentResponse>} - Command response.
   */
  async assignToAgent(...commandArguments) {
    return /** @type {import("../../../shared/task-automation-command-types.js").TaskAssignToAgentResponse} */ (await Task.executeCustomCommand({
      commandName: "assign-to-agent",
      commandType: "assign-to-agent",
      memberId: this.scalarPrimaryKeyValue("Custom member command Task#assignToAgent"),
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Task.resourcePath()
    }))
  }

  /**
   * Runs claimForAgent.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/task-automation-command-types.js").TaskAutomationTaskResponse>} - Command response.
   */
  async claimForAgent(...commandArguments) {
    return /** @type {import("../../../shared/task-automation-command-types.js").TaskAutomationTaskResponse} */ (await Task.executeCustomCommand({
      commandName: "claim-for-agent",
      commandType: "claim-for-agent",
      memberId: this.scalarPrimaryKeyValue("Custom member command Task#claimForAgent"),
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Task.resourcePath()
    }))
  }

  /**
   * Runs close.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{id: string, status: string}>} - Command response.
   */
  async close(...commandArguments) {
    return /** @type {{id: string, status: string}} */ (await Task.executeCustomCommand({
      commandName: "close",
      commandType: "close",
      memberId: this.scalarPrimaryKeyValue("Custom member command Task#close"),
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Task.resourcePath()
    }))
  }

  /**
   * Runs heartbeatAgentClaim.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/task-automation-command-types.js").TaskAutomationTaskResponse>} - Command response.
   */
  async heartbeatAgentClaim(...commandArguments) {
    return /** @type {import("../../../shared/task-automation-command-types.js").TaskAutomationTaskResponse} */ (await Task.executeCustomCommand({
      commandName: "heartbeat-agent-claim",
      commandType: "heartbeat-agent-claim",
      memberId: this.scalarPrimaryKeyValue("Custom member command Task#heartbeatAgentClaim"),
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Task.resourcePath()
    }))
  }

  /**
   * Runs markAgentReady.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/task-automation-command-types.js").TaskAutomationTaskResponse>} - Command response.
   */
  async markAgentReady(...commandArguments) {
    return /** @type {import("../../../shared/task-automation-command-types.js").TaskAutomationTaskResponse} */ (await Task.executeCustomCommand({
      commandName: "mark-agent-ready",
      commandType: "mark-agent-ready",
      memberId: this.scalarPrimaryKeyValue("Custom member command Task#markAgentReady"),
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Task.resourcePath()
    }))
  }

  /**
   * Runs postAutomationReply.
   * @param {import("../../../shared/task-automation-command-types.js").TaskAutomationReplyRequest} payload - Command argument.
   * @returns {Promise<import("../../../shared/task-automation-command-types.js").TaskAutomationReplyResponse>} - Command response.
   */
  async postAutomationReply(payload) {
    return /** @type {import("../../../shared/task-automation-command-types.js").TaskAutomationReplyResponse} */ (await Task.executeCustomCommand({
      commandName: "post-automation-reply",
      commandType: "post-automation-reply",
      memberId: this.scalarPrimaryKeyValue("Custom member command Task#postAutomationReply"),
      payload: Task.normalizeCustomCommandPayloadArguments([payload]),
      resourcePath: Task.resourcePath()
    }))
  }

  /**
   * Runs releaseAgentClaim.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/task-automation-command-types.js").TaskAutomationTaskResponse>} - Command response.
   */
  async releaseAgentClaim(...commandArguments) {
    return /** @type {import("../../../shared/task-automation-command-types.js").TaskAutomationTaskResponse} */ (await Task.executeCustomCommand({
      commandName: "release-agent-claim",
      commandType: "release-agent-claim",
      memberId: this.scalarPrimaryKeyValue("Custom member command Task#releaseAgentClaim"),
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Task.resourcePath()
    }))
  }

  /**
   * Runs resumeAgentWork.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<import("../../../shared/task-automation-command-types.js").TaskAutomationTaskResponse>} - Command response.
   */
  async resumeAgentWork(...commandArguments) {
    return /** @type {import("../../../shared/task-automation-command-types.js").TaskAutomationTaskResponse} */ (await Task.executeCustomCommand({
      commandName: "resume-agent-work",
      commandType: "resume-agent-work",
      memberId: this.scalarPrimaryKeyValue("Custom member command Task#resumeAgentWork"),
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Task.resourcePath()
    }))
  }

  /**
   * Runs syncAutomationRuntime.
   * @param {...FrontendModelAttributeValue} commandArguments - Custom command arguments.
   * @returns {Promise<{delivered: string[], runtimeState: string | null, status: "ok"}>} - Command response.
   */
  async syncAutomationRuntime(...commandArguments) {
    return /** @type {{delivered: string[], runtimeState: string | null, status: "ok"}} */ (await Task.executeCustomCommand({
      commandName: "sync-automation-runtime",
      commandType: "sync-automation-runtime",
      memberId: this.scalarPrimaryKeyValue("Custom member command Task#syncAutomationRuntime"),
      payload: Task.normalizeCustomCommandPayloadArguments(commandArguments),
      resourcePath: Task.resourcePath()
    }))
  }

  /**
   * Returns comments relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./comment.js").Comment, import("./comment.js").CommentCreateAttributes>} - Relationship helper.
   */
  commentsRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./comment.js").Comment, import("./comment.js").CommentCreateAttributes>} */ (this.getRelationshipByName("comments")) }

  /**
   * Returns comments.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./comment.js").Comment, import("./comment.js").CommentCreateAttributes>} - Relationship helper.
   */
  comments() { return this.commentsRelationship() }

  /**
   * Returns loaded comments.
   * @returns {Array<import("./comment.js").Comment>} - Loaded related models.
   */
  commentsLoaded() { return this.commentsRelationship().loaded() }

  /**
   * Loads comments.
   * @returns {Promise<Array<import("./comment.js").Comment>>} - Loaded related models.
   */
  async loadComments() { return await this.commentsRelationship().load() }

  /**
   * Returns project relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Task, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} - Relationship helper.
   */
  projectRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Task, import("./project.js").Project, import("./project.js").ProjectCreateAttributes>} */ (this.getRelationshipByName("project")) }

  /**
   * Returns project.
   * @returns {import("./project.js").Project | null} - Loaded related model.
   */
  project() { return this.projectRelationship().loaded() }

  /**
   * Builds project.
   * @param {import("./project.js").ProjectCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./project.js").Project} - Built related model.
   */
  buildProject(attributes = {}) { return this.projectRelationship().build(attributes) }

  /**
   * Loads project.
   * @returns {Promise<import("./project.js").Project | null>} - Loaded related model.
   */
  async loadProject() { return await this.projectRelationship().load() }

  /**
   * Returns or loads project.
   * @returns {Promise<import("./project.js").Project | null>} - Loaded related model.
   */
  async projectOrLoad() { return await this.projectRelationship().orLoad() }

  /**
   * Sets project.
   * @param {import("./project.js").Project | null} model - Related model.
   * @returns {void}
   */
  setProject(model) { this.projectRelationship().setLoaded(model) }

  /**
   * Returns taskAssignedUsers relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./task-assigned-user.js").TaskAssignedUser, import("./task-assigned-user.js").TaskAssignedUserCreateAttributes>} - Relationship helper.
   */
  taskAssignedUsersRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./task-assigned-user.js").TaskAssignedUser, import("./task-assigned-user.js").TaskAssignedUserCreateAttributes>} */ (this.getRelationshipByName("taskAssignedUsers")) }

  /**
   * Returns taskAssignedUsers.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./task-assigned-user.js").TaskAssignedUser, import("./task-assigned-user.js").TaskAssignedUserCreateAttributes>} - Relationship helper.
   */
  taskAssignedUsers() { return this.taskAssignedUsersRelationship() }

  /**
   * Returns loaded taskAssignedUsers.
   * @returns {Array<import("./task-assigned-user.js").TaskAssignedUser>} - Loaded related models.
   */
  taskAssignedUsersLoaded() { return this.taskAssignedUsersRelationship().loaded() }

  /**
   * Loads taskAssignedUsers.
   * @returns {Promise<Array<import("./task-assigned-user.js").TaskAssignedUser>>} - Loaded related models.
   */
  async loadTaskAssignedUsers() { return await this.taskAssignedUsersRelationship().load() }

  /**
   * Returns taskBoards relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./task-board.js").TaskBoard, import("./task-board.js").TaskBoardCreateAttributes>} - Relationship helper.
   */
  taskBoardsRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./task-board.js").TaskBoard, import("./task-board.js").TaskBoardCreateAttributes>} */ (this.getRelationshipByName("taskBoards")) }

  /**
   * Returns taskBoards.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./task-board.js").TaskBoard, import("./task-board.js").TaskBoardCreateAttributes>} - Relationship helper.
   */
  taskBoards() { return this.taskBoardsRelationship() }

  /**
   * Returns loaded taskBoards.
   * @returns {Array<import("./task-board.js").TaskBoard>} - Loaded related models.
   */
  taskBoardsLoaded() { return this.taskBoardsRelationship().loaded() }

  /**
   * Loads taskBoards.
   * @returns {Promise<Array<import("./task-board.js").TaskBoard>>} - Loaded related models.
   */
  async loadTaskBoards() { return await this.taskBoardsRelationship().load() }

  /**
   * Returns taskType relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Task, import("./task-type.js").TaskType, import("./task-type.js").TaskTypeCreateAttributes>} - Relationship helper.
   */
  taskTypeRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Task, import("./task-type.js").TaskType, import("./task-type.js").TaskTypeCreateAttributes>} */ (this.getRelationshipByName("taskType")) }

  /**
   * Returns taskType.
   * @returns {import("./task-type.js").TaskType | null} - Loaded related model.
   */
  taskType() { return this.taskTypeRelationship().loaded() }

  /**
   * Builds taskType.
   * @param {import("./task-type.js").TaskTypeCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./task-type.js").TaskType} - Built related model.
   */
  buildTaskType(attributes = {}) { return this.taskTypeRelationship().build(attributes) }

  /**
   * Loads taskType.
   * @returns {Promise<import("./task-type.js").TaskType | null>} - Loaded related model.
   */
  async loadTaskType() { return await this.taskTypeRelationship().load() }

  /**
   * Returns or loads taskType.
   * @returns {Promise<import("./task-type.js").TaskType | null>} - Loaded related model.
   */
  async taskTypeOrLoad() { return await this.taskTypeRelationship().orLoad() }

  /**
   * Sets taskType.
   * @param {import("./task-type.js").TaskType | null} model - Related model.
   * @returns {void}
   */
  setTaskType(model) { this.taskTypeRelationship().setLoaded(model) }

  /**
   * Returns uploadedFiles relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./uploaded-file.js").UploadedFile, import("./uploaded-file.js").UploadedFileCreateAttributes>} - Relationship helper.
   */
  uploadedFilesRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./uploaded-file.js").UploadedFile, import("./uploaded-file.js").UploadedFileCreateAttributes>} */ (this.getRelationshipByName("uploadedFiles")) }

  /**
   * Returns uploadedFiles.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelHasManyRelationship<Task, import("./uploaded-file.js").UploadedFile, import("./uploaded-file.js").UploadedFileCreateAttributes>} - Relationship helper.
   */
  uploadedFiles() { return this.uploadedFilesRelationship() }

  /**
   * Returns loaded uploadedFiles.
   * @returns {Array<import("./uploaded-file.js").UploadedFile>} - Loaded related models.
   */
  uploadedFilesLoaded() { return this.uploadedFilesRelationship().loaded() }

  /**
   * Loads uploadedFiles.
   * @returns {Promise<Array<import("./uploaded-file.js").UploadedFile>>} - Loaded related models.
   */
  async loadUploadedFiles() { return await this.uploadedFilesRelationship().load() }

  /**
   * Returns user relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Task, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  userRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Task, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("user")) }

  /**
   * Returns user.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  user() { return this.userRelationship().loaded() }

  /**
   * Builds user.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildUser(attributes = {}) { return this.userRelationship().build(attributes) }

  /**
   * Loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadUser() { return await this.userRelationship().load() }

  /**
   * Returns or loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async userOrLoad() { return await this.userRelationship().orLoad() }

  /**
   * Sets user.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setUser(model) { this.userRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(Task)

export {Task}

export default Task
